import { Platform, Pressable, StyleSheet, Text } from 'react-native';
import { CustomErrorBoundary } from "@/components/CustomErrorBoundary";
import { View } from '@/components/Themed';
import Head from 'expo-router/head';
import { StatusBar } from 'expo-status-bar';
import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { Meta } from '@/components/Meta';

export default function ErrorScreen() {
  const router = useRouter();

  const onPress = useCallback(() => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.navigate("/diagnostics");
    }
  }, [router]);
  
  return (
    <>
      <Meta title={"Error"} />
      <CustomErrorBoundary
        title="Fatal error"
        errorMessage="A fatal error has occurred."
        dismissText="OK"
        onDismiss={onPress}
      />
    </>
  );
}
